import {isNullish} from '../../../utils/Utils';
import {HTMLVideoElementProxy} from '../HTMLVideoElementProxy';

export default class HTMLVideoElementStatisticsProvider {
  private previousTotalDroppedFrames = 0;

  constructor(private videoElement: HTMLVideoElementProxy | undefined) {}

  getDroppedFrames(): number {
    if (this.videoElement == undefined) {
      return 0;
    }

    const playbackQuality = this.videoElement.getVideoPlaybackQuality();
    if (isNullish(playbackQuality)) {
      return 0;
    }

    const droppedFrames = playbackQuality.droppedVideoFrames;
    const currentDroppedFrames = droppedFrames - this.previousTotalDroppedFrames;
    this.previousTotalDroppedFrames = droppedFrames;
    return currentDroppedFrames;
  }
  reset() {
    this.previousTotalDroppedFrames = 0;
  }
}
